import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import CategoryView from '@/pages/category/components/CategoryView';
import { guomanComics } from '@/mocks/comics';

export default function Guoman() {
  return (
    <>
      <Navbar />
      <main>
        <CategoryView
          type="guoman"
          label="国漫"
          tagline="国漫分类大全，玄幻、武侠、古风、都市等题材一站收录。按题材快速筛选，热门连载与经典国漫作品都能在这里找到。"
          comics={guomanComics}
        />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}